/* ============
 * supplier Transformer
 * ============
 */

import Transformer from './transformer';
import ContactTransformer from './supplierContact';
import AddressTransformer from './supplierAddress';

export default class SupplierTransformer extends Transformer {

  static fetch(supplier) {
    return {
      id: supplier.id,
      name: supplier.name,
      code: supplier.code,
      number: supplier.number,
      address: supplier.address !== undefined ? AddressTransformer.fetch(supplier.address) : [],
      contact: supplier.contact !== undefined ? ContactTransformer.fetch(supplier.contact) : [],
    };
  }

  static send(supplier) {
    return {
      id: supplier.id,
      name: supplier.name,
      code: supplier.code,
      number: supplier.number,
      email: supplier.email,
      street_name_1: supplier.streetName1,
      street_name_2: supplier.streetName2,
      country_id: supplier.countryId,
      city: supplier.city,
      postal_code: supplier.postalCode,
      phonenumber: supplier.phonenumber,
      mobilenumber: supplier.mobilenumber,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/supplier.js